import { Pipe, PipeTransform } from '@angular/core';

import { IProduct } from '../../shared/models/product.model';
import { IEnclosure } from '../../shared/models/enclosure.model';
import { EnclosureTabType } from '../../shared/models/project.model';
import { fieldHightIsHigherThenMax } from '../../enclosure/helpers/positions-calculations.helper';

@Pipe({
    name: 'zoomInSwitchboardUnavailable',
    standalone: false
})
export class ZoomInSwitchboardUnavailablePipe implements PipeTransform {

  transform(zoomFactor: number,
            products: IProduct[],
            selectedEnclosure: IEnclosure,
            switchboardContainerEl: HTMLElement,
            zoomControlsContainerEl: HTMLElement,
            tab: EnclosureTabType): boolean {
    if (tab !== EnclosureTabType.DISPOSITION || !switchboardContainerEl || !zoomControlsContainerEl || !selectedEnclosure) {
      return false;
    }

    return fieldHightIsHigherThenMax(products, selectedEnclosure, switchboardContainerEl, zoomControlsContainerEl, zoomFactor + 1);
  }

}
